import $ from "jquery";
import tns from "tiny-slider";
import tippy from "tippy.js";

const widgets = document.querySelectorAll(".js-product-interact");
[...widgets].forEach(widget => {
  const navContainer = widget.querySelector(".js-controls");

  tns({
    container: widget.querySelector(".js-images"),
    navContainer,
    controls: false,
    items: 1,
    mode: "gallery"
  });

  tns({
    container: widget.querySelector(".js-texts"),
    navContainer,
    controls: false,
    items: 1,
    mode: "gallery"
  });
});

$(".js-product-interact").on(
  "click",
  ".js-product-interact-stats",
  triggerStatsUpdate
);

function triggerStatsUpdate(e) {
  if (!e.target.classList.contains("js-trigger")) return;

  $(document).trigger("product:interact.stats", {
    container: e.currentTarget,
    trigger: e.target
  });

  tippy.hideAll();
}
